<section>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Reports</li>
            <li class="breadcrumb-item active">Error Log</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><img src="../../../../assets/img/report.png"> Error Log</span>
                        <div class="float-right">
                            <!-- <button pButton (click)="clear(dt2)" label="Clear" class="p-button-raised" icon="pi pi-trash" 
                            style="height: 30px;background-color: aliceblue;color: #1a90d0;"></button> -->
                        </div>                       
                        &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <!-- <form [formGroup]="errorLogReportForm" novalidate>
    <div class="card">  
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-12">
                        <div class="p-fluid p-formgrid p-grid">
                                <div style="margin-left: auto; margin-right: auto; width: 25%;">
                                    <label for="startDate">Start Date<span class="required-field">*</span></label>
                                    <p-calendar class="reportdatepicker" [showIcon]="true" inputId="navigators" formControlName="startDate" (onSelect)="onSelectStartDate($event)" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030"></p-calendar>                          
                                </div>
                                <div style="margin-left: auto; margin-right: auto; width: 25%;">
                                    <label for="endDate">End Date<span class="required-field">*</span></label>
                                    <p-calendar class="reportdatepicker" [showIcon]="true" inputId="navigators" formControlName="endDate" [minDate]="maxDate" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030"></p-calendar>                          
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
          <div class="text-center">
            <button class="bg-success" pButton pRipple type="button" [disabled]="!this.errorLogReportForm.valid" (click)="generateErrorLogReport(errorLogReportForm,dt2)" style="background-color: #1a90d0; color: white;font-weight: bold;"><img src="../../../../assets/img/New-rep.png" width="32px">Get Report</button>
          </div>
        </div>
        <br><br><br>
    </div>
    <br>
    <br>
</form> -->
</section>
<section>
    <div [hidden]="!showTable" class="card">
        <div class="card-header">
           <span class="text-lg font-weight-bold">Error Log Report</span>
           <div class="card-tools">
            <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash"
            (click)="clearFilter(dt2)" style="float: left;height: 30px;"></button>
            <button pButton label="Export" class="p-button-raised  m-2" *ngIf="sharedService.checkPermission('Admin_Export')" (click)="exportErrorLogReport()"
            icon="pi pi-file-excel" type="button" style="height: 30px;"></button>
            <p-multiSelect [options]="allColumns" [(ngModel)]="selectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected" optionLabel="header"  [showHeader] = "false">
                <ng-template let-column pTemplate="item">
                    <div class="column-item">
                        <div>{{column.header}}</div>
                    </div>
                </ng-template>
            </p-multiSelect>
            
        </div>
        </div>
        <div class="card-body" id="page-admin">
            <p-table #dt2 [value]="errorLogReportList" [lazy]="true"
                (onLazyLoad)="loadErrorLogReportList($event)" paginatorDropdownAppendTo="body" dataKey="vendorCompanyName" [rows]="10"
                [showCurrentPageReport]="true" [resizableColumns]="true" columnResizeMode="expand"
                [rowsPerPageOptions]="[10,25,50,100,250,500,1000]" styleClass="p-datatable-gridlines"  [scrollable]="true" scrollHeight="350px"  [responsive]="true"
                [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup [attr.colspan]="selectedColumns.length">
                        <col style="width: 3rem;">
                        <col style="width: 6rem" *ngIf="isShowColumns('id')">
                        <col style="width: 8rem" *ngIf="isShowColumns('logged')">
                        <col style="width: 7rem" *ngIf="isShowColumns('level')">
                        <col style="width: 8.5rem" *ngIf="isShowColumns('message')">
                        <col style="width: 8rem" *ngIf="isShowColumns('logger')">
                        <col style="width: 9rem" *ngIf="isShowColumns('properties')">
                        <col style="width: 8.5rem;" *ngIf="isShowColumns('callsite')">
                        <col style="width: 9rem;" *ngIf="isShowColumns('exception')">
                        <col style="width: 9.5rem;" *ngIf="isShowColumns('userAgent')"> 
                        <col style="width: 9.5rem;" *ngIf="isShowColumns('ipAddress')"> 
                        <col style="width: 10rem;" *ngIf="isShowColumns('requestUrl')"> 
                        <col style="width: 10rem;" *ngIf="isShowColumns('queryString')"> 
                        <col style="width: 10rem;" *ngIf="isShowColumns('apiMethod')"> 
                        <col style="width: 10rem;" *ngIf="isShowColumns('postedBody')">        
       
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="background-color: #1a90d0;color: rgb(255 255 255);width: 3rem;" pResizableColumn>#</th>
                        <th *ngIf="isShowColumns('id')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 6rem;" pResizableColumn>ID 
                            <span pSortableColumn="id" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="id" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-numeric-filter [field]="'id'" [filters]="filters" [table]="table"
                            (applyFilter)="applyFilterNew()"></app-numeric-filter>
                            </th>
                        <th *ngIf="isShowColumns('logged')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 8rem;" pResizableColumn>Logged 
                            <span pSortableColumn="logged" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="logged" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-date-filter [field]="'logged'" [filters]="filters" [table]="table"
                            (filterDate)="loggedDateFilterData($event)"
                            [filterData]="loggedDateFilterValue"></app-date-filter>
                            </th>
                
                            <th *ngIf="isShowColumns('level')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 7rem;" pResizableColumn>Level 
                            <span pSortableColumn="level" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="level" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'level'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('message')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 8.5rem;" pResizableColumn>Message 
                            <span pSortableColumn="message" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="message" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'message'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('logger')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 8rem;" pResizableColumn>Logger 
                            <span pSortableColumn="logger" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="logger" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'logger'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('properties')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 9rem;" pResizableColumn>Properties 
                            <span pSortableColumn="properties" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="properties" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'properties'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('callsite')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 8.5rem;" pResizableColumn>Call Site 
                            <span pSortableColumn="callsite" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="callsite" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'callsite'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('exception')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 9rem;" pResizableColumn>Exception 
                            <span pSortableColumn="exception" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="exception" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'exception'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('userAgent')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 9.5rem;" pResizableColumn>User Agent 
                            <span pSortableColumn="userAgent" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="userAgent" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'userAgent'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('ipAddress')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 9.5rem;" pResizableColumn>IP Address 
                            <span pSortableColumn="ipAddress" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="ipAddress" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'ipAddress'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('requestUrl')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 10rem;" pResizableColumn>Request URL 
                            <span pSortableColumn="requestUrl" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="requestUrl" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'requestUrl'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('queryString')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 10rem;" pResizableColumn>Query String 
                            <span pSortableColumn="queryString" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="queryString" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'queryString'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('apiMethod')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 10rem;" pResizableColumn>API Method 
                            <span pSortableColumn="apiMethod" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="apiMethod" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'apiMethod'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('postedBody')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 10rem;" pResizableColumn>Posted Body 
                            <span pSortableColumn="postedBody" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="postedBody" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'postedBody'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                    </tr>
                    <tr>
                        <th></th>
                        <th *ngIf="isShowColumns('id')">{{filters?.id[0]?.value}}</th>
                        <th *ngIf="isShowColumns('logged')">
                            <div *ngIf="loggedDateFilterValue != undefined">
                                {{loggedDateFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span *ngIf="loggedDateFilterValue.length > 1">-</span> {{loggedDateFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                            </div>
                        </th>                       
                        <th *ngIf="isShowColumns('level')">{{filters?.level[0]?.value}}</th>
                        <th *ngIf="isShowColumns('message')">{{filters?.message[0]?.value}}</th>
                        <th *ngIf="isShowColumns('logger')">{{filters?.logger[0]?.value}}</th>
                        <th *ngIf="isShowColumns('properties')">{{filters?.properties[0]?.value}}</th>
                        <th *ngIf="isShowColumns('callsite')">{{filters?.callsite[0]?.value}}</th>
                        <th *ngIf="isShowColumns('exception')">{{filters?.exception[0]?.value}}</th>
                        <th *ngIf="isShowColumns('userAgent')">{{filters?.userAgent[0]?.value}}</th>
                        <th *ngIf="isShowColumns('ipAddress')">{{filters?.ipAddress[0]?.value}}</th>
                        <th *ngIf="isShowColumns('requestUrl')">{{filters?.requestUrl[0]?.value}}</th>
                        <th *ngIf="isShowColumns('queryString')">{{filters?.queryString[0]?.value}}</th>
                        <th *ngIf="isShowColumns('apiMethod')">{{filters?.apiMethod[0]?.value}}</th>
                        <th *ngIf="isShowColumns('postedBody')">{{filters?.postedBody[0]?.value}}</th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-errorLogReportList let-rowIndex="rowIndex">
                    <tr>
                        <td style = "width: 3rem">{{rowIndex + 1}}</td>
                        <td style = "width: 6rem" *ngIf="isShowColumns('id')">
                            <span class="table-col-view"><a [routerLink]="" (click)="showErrorLogDetails(errorLogReportList.id)">{{errorLogReportList.id}}</a></span></td>
                        <td style = "width: 8rem" *ngIf="isShowColumns('logged')">{{errorLogReportList.logged | date:'MM/dd/yyyy'}}</td>
                        <td style = "width: 7rem" *ngIf="isShowColumns('level')">{{errorLogReportList.level}}</td>
                        <td style = "width: 8.5rem" *ngIf="isShowColumns('message')">{{errorLogReportList.message}}</td>
                        <td style = "width: 8rem" *ngIf="isShowColumns('logger')">{{errorLogReportList.logger}}</td>
                        <td style = "width: 9rem" *ngIf="isShowColumns('properties')">{{errorLogReportList.properties}}</td>
                        <td style = "width: 8.5rem" *ngIf="isShowColumns('callsite')">{{errorLogReportList.callsite}}</td>
                        <td style = "width: 9rem" *ngIf="isShowColumns('exception')">{{errorLogReportList.exception}}</td>
                        <td style = "width: 9.5rem" *ngIf="isShowColumns('userAgent')">{{errorLogReportList.userAgent}}</td>
                        <td style = "width: 9.5rem" *ngIf="isShowColumns('ipAddress')">{{errorLogReportList.ipAddress}}</td>
                        <td style = "width: 10rem" *ngIf="isShowColumns('requestUrl')">{{errorLogReportList.requestUrl}}</td>
                        <td style = "width: 10rem" *ngIf="isShowColumns('queryString')">{{errorLogReportList.queryString}}</td>
                        <td style = "width: 10rem" *ngIf="isShowColumns('apiMethod')">{{errorLogReportList.apiMethod}}</td>
                        <td style = "width: 10rem" *ngIf="isShowColumns('postedBody')">{{errorLogReportList.postedBody}}</td>

                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="selectedColumns.length">No error log report found.</td>
                    </tr>
                  </ng-template>
            </p-table>
        </div>      
    </div>
    <!-- <br><br><br><br> -->
</section>